export enum DeployPriorityAtomicRuleProperty {
  NonDeploymentScore = 1,
  AutoDeploymentScore = 2,
  SensitivityScore = 3,
  ManuallyFlagged = 4,
  HoursUntilDue = 5,

  Rescheduled = 6,
}
